declare const document: any;

export const downloadFile = (label: string, filepath: string) => {
    const link = document.createElement('a')
    link.href = filepath;
    link.download = label;
    link.click()
    link.remove()
} 